import Layout from 'layout';
import PrequalificationReviewFormDetail from 'features/PrequalificationReview/pages/Detail';
import { LayoutProvider } from '../layout/context/layoutcontext';

function PrequalificationReviewDetailPage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <PrequalificationReviewFormDetail />
      </Layout>
    </LayoutProvider>
  );
}

export default PrequalificationReviewDetailPage;
